/* Persist a generated fighter across the homepage-to-builder navigation. */
(() => {
  const databaseName = 'lbox-loadout-session';
  const storeName = 'quick-create';
  const key = 'pending';

  function openDatabase() {
    return new Promise((resolve,reject) => {
      const request = indexedDB.open(databaseName,1);
      request.onupgradeneeded = () => request.result.createObjectStore(storeName);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  async function request(mode,operation) {
    const database = await openDatabase();
    try {
      return await new Promise((resolve,reject) => {
        const transaction = database.transaction(storeName,mode);
        const result = operation(transaction.objectStore(storeName));
        result.onsuccess = () => resolve(result.result);
        result.onerror = () => reject(result.error);
      });
    } finally {
      database.close();
    }
  }

  window.LBoxQuickCreateStore = {
    read:() => request('readonly',store => store.get(key)),
    write:value => request('readwrite',store => store.put(value,key)),
    clear:() => request('readwrite',store => store.delete(key))
  };
})();
